<template>
  <div class="enjoy-area si-without-border-radius pb-100">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="enjoy-img">
            <img src="@/assets/images/enjoy.png" alt="enjoy" />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="enjoy-content">
            <span class="top-title">استمتع بالمشاهدة</span>
            <h2>استمتع بالرياضة، الأفلام، البرامج التلفزيونية والمزيد</h2>
            <p>
              مع مجموعتنا الكبيرة والشاملة من القنوات التلفزيونية، لن تفوتك مبارياتك الرياضية المفضلة وبرامجك المفضلة بعد الآن.
            </p>
            <h4>اشترك في باقة الـ IPTV واحصل على دعم فني مجاني لمدة شهر كامل</h4>
            <div class="row align-items-center mb-30">
              <div class="col-lg-4 col-sm-6">
                <div class="starting-form mb-sm-0">
                  <span>الأسعار تبدأ من</span>
                  <h1>$ 9.99<sub>/ شهرياً</sub></h1>
                </div>
              </div>
              <div class="col-lg-8 col-sm-6">
                <div class="nestor-prepaid">
                  <span>باقات التفعيل الفوري</span>
                  <h3>ادفع فقط مقابل المدة التي تحتاجها دون عقود</h3>
                  <a
                    href="https://wa.me/447429916178"
                    target="_blank"
                    class="read-more style-two text-grey-teal"
                  >
                    لمعرفة المزيد
                    <i class="ti ti-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <a href="https://wa.me/447429916178" target="_blank" class="btn bg-grey-teal">
              <span class="border-style">عرض جميع خطط الأسعار</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EnjoySports",
});
</script>